// extracted by mini-css-extract-plugin
module.exports = {"zoneInfo":"styles_zoneInfo__2iwI-"};